
import React, { Component, PropTypes } from 'react';
import Modal from 'react-modal';
import { StyledModalCloseButton } from './styles';

// required for accessiblity stuff.
Modal.setAppElement('#nna-payment-estimator');

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    zIndex: 1100,
  },
  content: {
    position: 'absolute',
    // maxWidth: '500px',
    maxHeight: '100%',
    width: 'none',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '0px',
    outline: 'none',
    padding: '20px',
    zIndex: 1200,
    'transition-duration': '400ms'
  },
};

class AppModal extends Component {
  static propTypes = {
    onClose: PropTypes.func,
    isModalOpen: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.object
    ]).isRequired,
    children: PropTypes.node.isRequired,
    contentLabel: PropTypes.string.isRequired,
    disableClose: PropTypes.bool,
    title: PropTypes.string,
    hideCloseButton: PropTypes.bool,
    modalStyles: PropTypes.object
  }
  static defaultProps = {
    onClose: undefined,
    isModalOpen: false,
    disableClose: false,
    title: undefined,
    hideCloseButton: false,
    contentLabel: '',
    modalStyles: {}
  }
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: this.props.isModalOpen
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.isModalOpen !== nextProps.isModalOpen) {
      this.setState({
        modalIsOpen: nextProps.isModalOpen
      })
    }
  }
  openModal() {
    this.setState({ modalIsOpen: true });
  }
  closeModal() {
    const { disableClose, onClose } = this.props;
    if (disableClose === true) {
      return;
    }
    this.setState({ modalIsOpen: false });
    if (onClose) {
      onClose();
    }
  }
  renderCloseButton() {
    const { hideCloseButton, disableClose } = this.props;
    return (!hideCloseButton && !disableClose) ?
      <StyledModalCloseButton
        onClick={this.closeModal}
      >
        X
      </StyledModalCloseButton>
      : undefined;
  }
  render() {
    const { children, title, contentLabel, modalStyles } = this.props;
    styles.content = { ...styles.content, ...modalStyles };
    return (
      <Modal
        contentLabel={contentLabel}
        isOpen={this.state.modalIsOpen ? true : false} //eslint-disable-line
        onRequestClose={this.closeModal}
        style={styles}
      >
        <div className="heading-second">
          {title}
          {this.renderCloseButton()}
        </div>
        {children}
      </Modal>
    );
  }
}

export default AppModal;



/** WEBPACK FOOTER **
 ** ./src/components/Modal/index.js
 **/